import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
// import { Link } from "react-router-dom";
import Link from 'hooks/Link';
const DealTerm = ({data}) => {
  return (
    <>
      <div className="deal-term">
        <div className="deal-term-header">
          <div className="deal-term-stats">
            <p className="deal-term-title">{data?.storeId?.title}</p>
            <p className="deal-term-stat">${data?.amountInvested}</p>
          </div>
          <div className="icon">
            <AiOutlineInfoCircle /> 
          </div>
        </div>
        {/* <div className="deal-term-body">
          <p className="deal-term-desc">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa,
            molestiae!
          </p>
          <Link href="#" className="primary">
            Learn more
          </Link>
        </div> */}
      </div>
    </>
  );
};

export default DealTerm;
